import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch } from 'react-redux';

import { hasPemissions } from '../../../commons/utils';
import { useResponseHandler } from '../../../hooks/useResponseHandler';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { alertInformativo } from '../../../commons/texts';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { mtDividerUpTable } from '../../../commons';
import { getShiftDemandsStore } from '../../../store/shift_demands/thunks';

import { TableShiftDemands } from './TableShiftDemands';
import { CreateShiftDemandModal } from './modals/CreateShiftDemandModal';
import { BannerInfoRequerimientoPersonal } from './components/BannerInfoRequerimientoPersonal';
import { Link } from 'react-router-dom';

export const RequeriminetoPersonal = () => {
    const dispatch = useDispatch<any>();
    const { handleResponse, ResponseComponents } = useResponseHandler();

    const [canCreate, setCanCreate] = useState(false);
    const [openCreate, setOpenCreate] = useState(false);

    const checkPermissions = async () => {
        const create = await hasPemissions('modulo.thumano', 'modulo.programador', 'create', 'modulo.programador.requerimiento.de.personal');
        if (create) setCanCreate(true);
    };

    useEffect(() => {
        checkPermissions();
    }, []);

    return (
        <Box sx={{ pb: 5 }}>
            {ResponseComponents}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <BreadCrumbsAndTitle 
                        title="Requerimiento de Personal"
                        mainModule="Talento Humano"
                        parent=""
                        action="Requerimientos"
                        icon="People"
                    />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.requerimientoPersonal} /> 
                    </Typography>
                </Box>
                
                {canCreate && (
                     <Button 
                        variant="contained" 
                        color="primary" 
                        startIcon={<AddIcon />} 
                        component={Link}
                        to={'/talento-humano/programador/requerimiento-de-personal/crear'}
                        sx={{
                            borderRadius: 2, 
                            px: 3,
                            py: 1,
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                        }}
                    >Crear Requerimiento</Button>
                )}
            </Box>

            <Divider sx={{ marginBottom: mtDividerUpTable }}/>
            <TableShiftDemands />

            <BannerInfoRequerimientoPersonal />

            <CreateShiftDemandModal 
                open={openCreate} 
                setOpen={setOpenCreate} 
                onSuccess={() => {}}
            />
        </Box>
    );
};
